/**
 * Canonical date/time formatting for the dashboard. en-GB with fixed 2-digit
 * fields so output is stable regardless of browser locale — the single
 * replacement for the formatDate/formatTime copies that used to live inside
 * each table/card component.
 */

export const formatDate = (iso: string): string => {
  if (!iso) return '-';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '-';
  return date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
};

export const formatTime = (iso: string): string => {
  if (!iso) return '-';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '-';
  return date.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const formatDateTime = (iso: string): string => {
  if (!iso) return '-';
  const date = formatDate(iso);
  if (date === '-') return '-';
  return `${date} ${formatTime(iso)}`;
};
